import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import PortfolioStatementCriteria from "./PortfolioStatementCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";

@NeoReport("PortfolioStatement", { category: ReportCategory.InvestorReports })
export default class PortfolioStatementReport extends Report<PortfolioStatementCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache),
        public investorApiClient = AppService.get(DomainTypes.ApiClients.Investor)) {
        super(PortfolioStatementCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.entityId}
                  select={{ itemSource: this.dataCache.entities }}
                  label="Entity" />
                <Neo.FormGroup bindContext={this.criteria.meta.investorId}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.investorId}
                        bindDisplay={this.criteria.meta.investorName}
                        itemSource={this.investorApiClient.getInvestorLookups} />
                </Neo.FormGroup>
                <Neo.FormGroup bind={this.criteria.meta.startDate} />
                <Neo.FormGroup bind={this.criteria.meta.endDate} />
            </Neo.GridLayout>
        </div>;
    }
}